import { render, staticRenderFns } from "./modoUso.vue?vue&type=template&id=8aa84f28"
import script from "./modoUso.vue?vue&type=script&lang=js"
export * from "./modoUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports